exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toggleMultiselect .selectedIconPlaceholder{display:inline-block;width:1em;margin-right:5px}.toggleMultiselect .topContent{font-size:.8em;padding-right:10px;padding-left:20px;padding-bottom:5px;border-bottom:1px solid #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/inputs/toggle_multiselect.scss
// module id = 1447
// module chunks = 0